const accessConstructionManagement = {

    CONSTRUCTION_STAGE_LIST: {
        path: '/construction-stage-list'
    },

    ADD_CONSTRUCTION_STAGE: {
        path: '/add-construction-stage'
    },

    UPDATE_CONSTRUCTION_STAGE: {
        path: '/edit-construction-stage'
    },

    DELETE_CONSTRUCTION_STAGE: {
        path: '/delete-construction-stage'
    },

    CONSTRUCTION_LIST: {
        path: '/construction-list'
    },

    ADD_CONSTRUCTION: {
        path: '/add-construction'
    },

    DELETE_CONSTRUCTION: {
        path: '/delete-construction'
    },

    CONSTRUCTION_DETAILS: {
        path: '/construction-details'
    },

    ADD_CONSTRUCTION_DAILY_LOG: {
        path: '/add-construction-daily-log'
    },

    EDIT_CONSTRUCTION_DAILY_LOG: {
        path: '/edit-construction-daily-log'
    },

    DELETE_CONSTRUCTION_DAILY_LOG: {
        path: '/delete-construction-daily-log'
    },

}

export default accessConstructionManagement;
